import { create_api } from './base';

export default class DeliverableAddressRepo {
  // no-dd-sa:javascript-best-practices/no-unreachable
  baseUrl = '/';

  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_DELIVERABLE_ADDRESS_API);
  }

  get = (params) => this.api.get(`/address`, params);
}
